import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from "../services/authentication.service";

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  constructor(private authService: AuthenticationService) { }

  ngOnInit() {
    this.authService.reloadUserInfo();

    //start intercom live chat
    // window["Intercom"]("boot", {
    //   app_id: "isx1jbmb"
    // });
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/main/main.component.ts